import { useEffect } from 'react';
import { useLocale } from '../../../../../shared/i18n/locale/useLocale';
import { useNewBookingStore } from '../../../../domain/booking/stores/useNewBookingsStore';

export function useLoadParkingProductsWhenNeeded() {
	const { parkingProductsQuoteStore, booking, originalBooking } =
		useNewBookingStore();
	const { code: locale } = useLocale();

	useEffect(() => {
		if (
			!parkingProductsQuoteStore.finishedInitialLoad &&
			!parkingProductsQuoteStore.isLoading &&
			booking.entryDate &&
			booking.exitDate
		) {
			parkingProductsQuoteStore.load({
				entryDate: new Date(booking.entryDate),
				entryTime: booking.entryTime,
				exitDate: new Date(booking.exitDate),
				exitTime: booking.exitTime,
				promoCode: booking.promoCode,
				locale,
				reference: originalBooking?.reference,
			});
		}
	}, [
		parkingProductsQuoteStore.finishedInitialLoad,
		parkingProductsQuoteStore.isLoading,
		booking.entryDate,
		booking.exitDate,
		originalBooking?.reference,
	]);
}
